<template>
  <div class="dash">
    <comHeader
      :active="active"
      :value="value"
      style="background-color: rgba(42, 40, 80, 1); border: none"
    ></comHeader>
    <div class="main_body">
      <div class="main_top">
        <div class="main_sear">
          <div class="sea_tit">
            <img
              style="width: 30px"
              src="../../assets/img/ChatLibrary-logo.png"
              alt=""
            />
            <div class="sea_txt">{{ $t('chatresearch.theme') }}</div>
          </div>
          <div class="sea_box">
            <div class="sea_tab">
              <div class="switch" @click="swichSearch">
                <img
                  src="@/assets/img/u103.svg"
                  style="vertical-align: middle"
                />
                <span v-if="switchType === 1">{{ $t('chatresearch.switchTraditional') }}</span>
                <span v-else>{{ $t('chatresearch.switchSemantics') }}</span>
              </div>
            </div>
            <div class="sea_s" v-if="switchType === 1">
              <el-input
                type="textarea"
                :rows="5"
                :placeholder="$t('chatresearch.searchTip')"
                v-model="textarea"
                class="custom-textarea"
                style="overflow: hidden; resize: none"
              >
              </el-input>
              <div class="btn_sea">
                <!-- <el-radio v-model="radio" label="1">检索摘要</el-radio>
                <el-radio v-model="radio" label="2">检索全文</el-radio> -->
                <i
                  @click="search"
                  class="el-icon-search custom-icon"
                  style="font-size: 21px"
                ></i>
              </div>
            </div>
            <div class="sea_s_" v-else>
              <div class="sea_sel">
                <i
                  class="el-icon-circle-plus-outline"
                  style="color: #39a7b4; font-size: 28px"
                  @click="advancedadd()"
                ></i>

                <el-select
                  class="sel_"
                  v-model="advancedoptions"
                  :placeholder="$t('chatresearch.select')"
                  style="width: 300px"
                >
                  <el-option
                    v-for="item in conditionoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  class="sel_ sel_0'"
                  v-model="advancedinput"
                 
                  :placeholder="$t('chatresearch.tips')"
                >
                  <i
                  @click="advancedaddSearch"
                    slot="suffix"
                    class="el-icon-search custom-icon"
                    style="font-size: 21px"
                  ></i
                ></el-input>
              </div>
              <div
                class="searchdistrict_Advanced_box"
                ref="scrollContainer"
               
              >
                <div
                  class="searchdistrict_Advanced_bottom sea_sel"
                  v-for="(item, index) in addition"
                  :key="index"
                >
                  <i
                    class="el-icon-remove-outline"
                    style="color: #39a7b4; font-size: 28px"
                    @click="advanceddelete(index)"
                  ></i>
                  <el-select
                    class="sel_"
                    style="width: 145px"
                    v-model="item.logic"
                    :placeholder="$t('chatresearch.select')"
                  >
                    <el-option
                      v-for="item in option_state"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    class="sel_"
                    style="width: 145px; margin: 0 10px 0 0"
                    v-model="item.key"
                    :placeholder="$t('chatresearch.select')"
                  >
                    <el-option
                      v-for="item in conditionoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    class="sel_"
                    clearable
                    v-model="item.value"
                    placeholder=""
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img class="img_ai" src="../../assets/img/home_img/u108.png" alt="" />
      </div>
    </div>

    <div class="box">
      <div class="box_tit">
        <img src="../../assets/img/home_img/u49.png" alt="" />
        <div class="tit_txt">{{ $t('chatresearch.introduce_tit') }} </div>
      </div>
      <div class="box_txt">
        <p style="text-indent: 0em">
            {{ $t('chatresearch.introduceOne') }} 
        </p>
        <p>
            {{ $t('chatresearch.introduceTwo') }}
        </p>
        <p>
            {{ $t('chatresearch.introduceThree') }}
        </p>
      </div>
      <div class="box_img">
        <img class="bac_img" src="@/assets/img/home_img/笔记本.png"  />
        <img
          class="bac_img_con"
          src="../../assets/video/gif/research.gif"
          alt=""
        />
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>
<script>
import comHeader from "@/components/ComHeader.vue";
import ComFooter from "@/components/ComFooter_one.vue";
export default {
    data() {
        return {
        active: 5,
        switchType: 1,
        textarea: "",

        advancedinput: "",
        addition: [],
        advancedoptions: "title",
        value: "ChatResearch",
        radio: "1",
        option_state: [
            {
            value: "and",
            label: "AND",
            },
            {
            value: "or",
            label: "OR",
            },
            {
            value: "not",
            label: "NOT",
            },
        ],
        };
    },
    components: { ComFooter, comHeader },

    computed: {
        // 导航多语言 可以动态改变 ----官方推荐
        conditionoptions(){
            return [
                {
                    //高级检索条件options
                    value: "title",
                    label: this.$t("chatresearch.title"),
                },
                {
                    value: "author",
                    label: this.$t("chatresearch.author"),
                },
                {
                    value: "year",
                    label: this.$t("chatresearch.year"),
                },
                {
                    value: "subject",
                    label: this.$t("chatresearch.subject"),
                },
                {
                    value: "abstract",
                    label: this.$t("chatresearch.abstract"),
                },
                {
                    value: "issn",
                    label: this.$t("chatresearch.issn"),
                },
                {
                    value: "keyword",
                    label: this.$t("chatresearch.keywords"),
                },
            ]
        },
    },
    methods: {
        swichSearch() {
        if (this.switchType == 1) {
            this.switchType = 2;
        } else {
            this.switchType = 1;
        }
        },
        search() {
        this.$router.push({
            path: "/chatNewResearch",
            query: {
            showAll: true,
            textarea: this.textarea,
            },
        });
        },
        // 高度
        clientHight() {
        const box = document.querySelector(".searchdistrict_Advanced_box");
        const height = box.scrollHeight + 42;
        if (height >= 84) {
            box.scrollTop = height;
        }
        },
        handleScroll() {
        const scrollContainer = this.$refs.scrollContainer;
        if (
            scrollContainer.scrollHeight - scrollContainer.scrollTop ===
            scrollContainer.clientHeight
        ) {
            // 触发滚动到底部事件
            
        }
        },
        scrollToBottom() {
        const scrollContainer = this.$refs.scrollContainer;
        // 将容器滚动到底部
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
        },
        // 添加搜索规则
        advancedadd() {
        if (!this.advancedinput) {
            console.log(
            "1",
            document.getElementsByClassName("el-message").length < 1
            );
            if (document.getElementsByClassName("el-message").length < 1) {
            this.$message({
                message: this.$t("chatresearch.inputTips"),
                time: 800,
                type: "warning",
                customClass: "customClass",
            });
            return;
            }
        } else if (this.addition.length > 0) {
            if (this.addition[this.addition.length - 1].value == "") {
            this.$message.warning(this.$t("chatresearch.inputTips"));
            return;
            } else {
            this.addition.push({
                logic: "and",
                key: "title",
                value: "",
            });
            this.scrollToBottom();
            }
            this.$nextTick(() => {
            //   this.clientHight();
            this.scrollToBottom();
            });

            console.log("2");
        } else {
            this.addition.push({
            logic: "and",
            key: "title",
            value: "",
            });
            
            this.$nextTick(() => {
            //   this.clientHight();
            this.scrollToBottom();
            });
        }
        
        },
        // 删除规则
        advanceddelete(i) {
        this.addition.splice(i, 1);
        },
        advancedaddSearch() {
        this.$router.push({
            path: "/chatNewResearch",
            query: {
            switchType: 2,
            advancedinput: this.advancedinput,
            advancedoptions: this.advancedoptions,
            addition: JSON.stringify(this.addition),
            searchType: "result",
            },
        });
        },
    },
}
</script>

<style lang="less" scoped>
.dash {
  height: 100vh;
  min-width: 1200px;

  .main_page {
    min-height: calc(100vh - 50px);
    width: 100%;
    background: linear-gradient(
      179.99999999999994deg,
      rgba(207, 219, 245, 1) 0%,
      rgba(236, 223, 232, 1) 15%,
      rgba(255, 255, 255, 1) 31%
    );

    .warp {
      width: 90%;
      margin: auto;
      padding: 50px 0;
      padding-bottom: 20px;

      .warp_top {
        display: flex;
        align-items: center;
        min-width: 1150px;

        .warp_top_left {
          text-align: right !important;
          // line-height: 35px;
          width: 45%;

          .warp_tit {
            font-size: 35px;
            font-weight: 700;
            margin-bottom: 30px;

            img {
              vertical-align: bottom;
            }
          }

          .warp_info {
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 20px;
          }

          .warp_detail {
            font-size: 16px;
            line-height: 25px;
          }
        }

        .middle {
          width: 1px;
          border: 1px solid #797979;
          height: 230px;
          margin: 0 50px;
        }

        .warp_top_right {
          width: 45%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          .switch {
            cursor: pointer;
            margin-bottom: 8px;
            color: #e6a23c;

            img {
              margin-right: 5px;
              vertical-align: middle;
              height: 20px !important;
            }
          }

          .warp_search {
            width: 100%;
            height: 176px;
            background-color: #fff;
            box-shadow: 0px 0px 5px rgba(127, 127, 127, 0.34901960784313724);

            border-radius: 6px;
            overflow: hidden;

            /deep/ .el-textarea {
              width: 100%;
              height: 140px;

              border-radius: 4px;
            }

            /deep/ .el-textarea__inner {
              height: 140px;
              max-height: 140px;
              border-radius: 0px;
              border-color: #fff;
            }

            /deep/ .el-textarea__inner::-webkit-scrollbar {
              display: none;
            }

            .search_btn {
              display: flex;
              align-items: center;
              justify-content: flex-end;

              // margin-bottom: 5px;
              img {
                height: 30px;
                margin-right: 10px;
              }

              span {
                display: flex;
                align-items: center;
                background-color: #e6a23c;
                height: 30px;
                padding-left: 15px;
                padding-right: 5px;
                border-radius: 4px;
                margin-right: 5px;

                img {
                  height: 20px !important;
                }
              }
            }

            .searchdistrict_Advanced_top {
              display: flex;
              align-items: center;
              margin: 10px;

              /deep/ .el-select {
                margin-right: 10px;
                width: 50%;
              }

              /deep/ .el-input {
                margin-right: 10px;
              }
            }

            .fun_btn {
              width: 85px;
              display: flex;
              justify-content: space-between;
            }

            .searchdistrict_Advanced_bottom {
              display: flex;
              margin: 0 10px 10px 10px;

              .select {
                width: 50%;
                margin-right: 10px;

                .spanone {
                  width: 48%;
                  margin-right: 4%;
                }

                .spantwo {
                  width: 48%;
                }
              }

              /deep/ .el-input {
                margin-right: 10px;
              }
            }
          }
        }
      }
      @media screen and (max-width: 1400px) {
        .bottom_info {
          display: flex;
          align-items: center;

          .bottom_detail {
            margin-right: 60px;
            text-align: left;
            line-height: 30px;
            font-size: 16px;
            width: 476px !important;
            padding-left: 45px !important;
          }

          img {
            width: 580px !important;
            height: 345px !important;
          }
        }
        .bac_img {
          // width: 600px !important;
        }
      }

      .warp_bottom {
        margin-top: 60px !important;
        width: 1150px;
        margin: auto;
        display: flex;
        // background: #eee;
        // justify-content: center;
        padding: 0 40px;
        padding-bottom: 20px;
        position: relative;
        /deep/ .el-carousel--horizontal {
          width: 1150px;
          height: 434px;
        }
        /deep/ .el-carousel__container {
          height: 395px;
        }
        /deep/ .el-carousel__arrow {
          background-color: rgba(31, 45, 61, 0);
          color: transparent;
        }
        /deep/ .el-carousel__item.is-animating {
          transition: transform 5s ease-in-out;
        }
        /deep/ .el-carousel__indicators--outside {
          display: none;
        }

        // background: #797979;
        .bottom_info {
          display: flex;
          align-items: center;

          .bottom_detail {
            margin-right: 50px;
            text-align: left;
            line-height: 30px;
            font-size: 16px;
            width: 396px;
            padding-left: 15px;
          }

          img {
            width: 660px;
            height: 380px;
          }
        }

        .bac_img {
          position: absolute;
          top: -10px;
          right: 30px;
          z-index: 10;
        }
      }
    }
  }
}
.searchdistrict_Advanced_box {
  height: 100px;
  overflow-x: hidden;
  overflow-y: scroll;
  // overflow: auto;
  // max-height: 120px;
}
.searchdistrict_Advanced_box::-webkit-scrollbar {
  // display: none;
}
/* 修改滚动条轨道的样式 */
.searchdistrict_Advanced_box::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度 */
}

/* 修改滚动条的滑块样式 */
.searchdistrict_Advanced_box::-webkit-scrollbar-thumb {
  background-color: rgb(75 101 179); /* 滑块背景颜色 */
  border-radius: 3px; /* 滑块圆角 */
}

/* 修改滚动条的轨道样式 */
.searchdistrict_Advanced_box::-webkit-scrollbar-track {
  //   background-color: #f1f1f1; /* 轨道背景颜色 */
}

/* 修改滚动条的角落样式（如果需要） */
.searchdistrict_Advanced_box::-webkit-scrollbar-corner {
  //   background-color: #fff; /* 角落背景颜色 */
}
.main_body {
  // padding: 20px;
  //   margin: 20px;
  //   margin-top: 0;
  //   height: 300px;
  //   padding: 30px 0;
  
  background-color: rgba(42, 40, 80, 1);
}
.main_top {
  width: 80%;
  max-width: 1100px;
  //   width: 1100px;
  min-height: 299px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  .img_ai {
    width: 745px;
  }
}
.main_sear {
  position: absolute;
  left: 0;
  width: 700px;
  // margin: 20px 0 0 0;
  .sea_tit {
    display: flex;
    align-items: center;
    .sea_txt {
      color: white;
      font-weight: 600;
      font-size: 24px;
      margin: 0 0 0 12px;
      white-space: nowrap;
    }
  }
  .sea_box {
    width: 100%;
    // height: 200px;
  }
  .sea_tab {
    display: flex;
    justify-content: flex-end;
    margin: 0px 0 5px 0;
  }
}
.switch {
  color: #e6a23c;
  cursor: pointer;
  img {
    margin-right: 5px;
    vertical-align: middle;
    height: 20px !important;
  }
  span {
    margin: 0;
  }
}
.switch:hover {
  // color: #81602e;
}
/deep/ .custom-textarea .el-textarea__inner {
  background-color: rgba(255, 255, 255, 0.8);
  scrollbar-width: thin;
  scrollbar-color: #888 #f0f0f0;
  resize: none;
  border-start-end-radius: 4px;
  border-start-start-radius: 4px;
  border-end-end-radius: 0px;
  border-end-start-radius: 0px;
  border-color: transparent; /* 取消边框 */
}
/deep/ .custom-textarea .el-input__inner:focus {
  border-color: transparent; /* 焦点时也取消边框 */
}

/deep/ .custom-textarea .el-textarea__inner::-webkit-scrollbar {
  width: 5px;
  border-radius: 20px;
  //   background-color: rgb(199, 78, 78);
}

/deep/ .custom-textarea .el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: #888;
  border: 4px solid transparent;
  //   background-clip: padding-box;
  border-radius: 12px;
}
// /deep/ .custom-textarea textarea {
//   overflow: hidden !important; /* 禁用滚动条 */
//   resize: none; /* 禁止用户手动调整文本框的尺寸 */
//   height: auto !important; /* 强制将高度设置为自适应 */
//   max-height: none !important; /* 禁用最大高度限制 */
// }
.btn_sea {
  background: rgba(255, 255, 255, 0.8);
  padding: 5px 20px 10px 0;
  border-end-end-radius: 4px;
  border-end-start-radius: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  /deep/ .el-radio__inner {
    width: 12px;
    height: 12px;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: rgba(54, 54, 54, 0.8);
  }
  /deep/ .el-radio__inner::after {
    background-color: rgb(63, 63, 63);
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.8);
  }
}
.custom-icon {
  cursor: pointer;
  font-size: 21px;
  background: linear-gradient(
    45deg,
    #ff3333,
    #3352ff
  ); /* 设置渐变色，可以根据需要调整颜色和角度 */
  -webkit-background-clip: text; /* 使用 Webkit 前缀来启用背景色填充文本 */
  background-clip: text; /* 启用背景色填充文本 */
  -webkit-text-fill-color: transparent; /* 隐藏文本颜色 */
  display: inline-block; /* 使渐变色填充整个图标 */
}
.sea_s_ {
  min-height: 153px;
}
.sea_sel {
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
}
.sel_ {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border-radius: 20px;
    background: #d6deec;
    border-color: transparent;
  }
  /deep/ .el-input__inner:focus {
    border-color: transparent; /* 焦点时也取消边框 */
  }
  /deep/ .el-input__suffix {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-input__suffix-inner {
    display: inline-block;
  }
}
.sel_0 {
  /deep/ .el-input__inner {
    padding-right: 40px !important;
  }
}
.bac_img {
  width:1000px !important;
  height: 380px;
  right: 122px !important;
}
.box_img{
    width: 1000px;
}
.bac_img_con {
  width: 555px !important;
  height: 302px;
  position: relative;
  top: -350px;
}
.box {
  margin: 25px auto;
  width: 80%;
  max-width: 1000px;

  .box_tit {
    display: flex;
    align-items: center;
    justify-content: center;
    .tit_txt {
      margin: 0 0 0 10px;
      font-size: 25px;
      font-weight: 600;
    }
  }
  .box_txt {
    margin: 10px 0;
    text-indent: 2em;
    line-height: 28px;
    text-align: left;
    p {
      margin: 5px 0;
    }
  }
  .box_img {
    padding: 20px 0;
    height: 520px;
    img {
      width: 90%;
    }
  }
}

</style>
<style>
.content_ {
  max-width: 600px;
  font-size: 14px;
  line-height: 25px;
  text-indent: 2em;
  padding: 10px 20px;
}

.atooltip {
  background: rgba(48, 49, 51, 0.7) !important;
}
</style>
